import { jsx as m } from "react/jsx-runtime";
import { useValues as k, useTooltip as B } from "./chart-utils.js";
import { forwardRef as y, useEffect as C } from "react";
import { Tooltip as j } from "../../tooltip/tooltip.js";
import M from "../chart.module.css.js";
import b from "clsx/lite";
const z = y(
  function({ className: r, children: n, ...i }, l) {
    const [t, e] = k(l), s = b(M.bubbles, r);
    return C(() => {
      if (!t.length) return;
      const c = t.map(({ value: x }) => ({ x: 0, y: 0, r: x })), a = F(c), p = a.reduce((x, { x: h, y: u, r: f }) => Math.max(x, Math.abs(h) + f, Math.abs(u) + f), 0);
      t.forEach(({ el: { style: x } }, h) => {
        const { x: u, y: f, r: w } = a[h], g = `calc(${(w * 2 / p * 50).toFixed(3)}% - var(--gap))`;
        x.top = `${(50 + u / p * 50).toFixed(3)}%`, x.left = `${(50 + f / p * 50).toFixed(3)}%`, x.width = x.height = g;
      });
    }, [t]), /* @__PURE__ */ m("div", { className: s, ref: e, ...i, children: /* @__PURE__ */ m("div", { children: n }) });
  }
), P = y(
  function({ children: r, className: n, tooltip: i, value: l, ...t }, e) {
    return /* @__PURE__ */ m(
      j,
      {
        as: "div",
        className: b(M.bubble, n),
        "data-value": l,
        ref: e,
        ...B(i, r || l),
        ...t,
        children: r || l
      }
    );
  }
), F = (o) => {
  const { length: r } = o, [n, i, l] = o;
  if (!r || (n.x = n.y = 0, r === 1) || (n.x = -i.r, i.x = n.r, i.y = 0, r === 2)) return o;
  v(i, n, l);
  let t = { circle: n }, e = { circle: i }, s = { circle: l };
  t.next = s.prev = e, e.next = t.prev = s, s.next = e.prev = t;
  t: for (let c = 3; c < r; c++) {
    v(t.circle, e.circle, o[c]), s = { circle: o[c] };
    let a = e.next, p = t.prev, x = e.circle.r, h = t.circle.r;
    do
      if (x <= h) {
        if (d(a.circle, s.circle)) {
          ((e = a).next = e).prev = t, --c;
          continue t;
        }
        x += a.circle.r, a = a.next;
      } else {
        if (d(p.circle, s.circle)) {
          ((t = p).next = e).prev = t, --c;
          continue t;
        }
        h += p.circle.r, p = p.prev;
      }
    while (a !== p.next);
    s.prev = t, s.next = e, t.next = e.prev = e = s, e = t.next;
  }
  return o;
}, d = (o, r) => Math.pow(Math.max(0, o.r + r.r - 1e-6), 2) > Math.pow(r.x - o.x, 2) + Math.pow(r.y - o.y, 2), v = (o, r, n) => {
  const i = o.x - r.x, l = o.y - r.y, t = Math.pow(i, 2) + Math.pow(l, 2), e = Math.pow(r.r + n.r, 2), s = Math.pow(o.r + n.r, 2);
  if (!t)
    n.x = r.x + n.r, n.y = r.y;
  else if (e > s) {
    const c = (t + s - e) / (2 * t), a = Math.sqrt(Math.max(0, s / t - c * c));
    n.x = o.x - c * i - a * l, n.y = o.y - c * l + a * i;
  } else {
    const c = (t + e - s) / (2 * t), a = Math.sqrt(Math.max(0, e / t - c * c));
    n.x = r.x + c * i - a * l, n.y = r.y + c * l + a * i;
  }
};
export {
  P as ChartBubble,
  z as ChartBubbles
};
//# sourceMappingURL=chart-bubbles.js.map
